import onReady from '../utils/onReady';
import * as Events from '../utils/events';
import * as ClassList from '../utils/classList';
import domIterator from '../utils/domIterator';
import triggerCustomEvent from '../utils/triggerCustomEvent';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class mapsMenu {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        // Put your other DOM-specific initializations here, and get your class moving!
        this.dom.showButton = this.dom.container.querySelector('.maps-menu__show');
        this.dom.closeButton = this.dom.container.querySelector('.maps-menu__close');
        this.dom.nearbySearchButtons = this.dom.container.querySelectorAll('.maps-menu__button');

        this.addEvents();
    }


    addEvents() {
        Events.addEvent(this.dom.showButton, "click", () => {
            ClassList.add(this.dom.container, "maps-menu--active");
        });

        Events.addEvent(this.dom.closeButton, "click", () => {
            ClassList.remove(this.dom.container, "maps-menu--active");
        });

        // Listen for "enable-buttons" event, so we can reenable buttons once places search is done.
        Events.addEvent(this.dom.container.parentNode, "enable-buttons", () => {
            ClassList.remove(this.dom.container, "maps-menu--disabled");
        });

        // Listen for "remove-active" event, if there is no results from the search
        Events.addEvent(this.dom.container.parentNode, "remove-active", event => {
            let target = event.target || event.srcElement;
            ClassList.remove(target, "maps-menu__button--active");
            ClassList.add(target, "maps-menu__button--fail");

            window.setTimeout( () => {
                ClassList.remove(target, "maps-menu__button--fail");
            }, 50);
        });

        domIterator(this.dom.nearbySearchButtons, element => {
            Events.addEvent(element, "click", () => {
                if (ClassList.contains(element, "maps-menu__button--active")) {
                    ClassList.remove(element, "maps-menu__button--active");
                    triggerCustomEvent(element, 'nearby-search--off');
                } else {
                    // Disable buttons when search is in progress
                    ClassList.add(this.dom.container, "maps-menu--disabled");

                    ClassList.add(element, "maps-menu__button--active");
                    triggerCustomEvent(element, 'nearby-search--on');
                }
            });
        });
    }
}


export default mapsMenu;